<div
  class="bg-surface-200 dark:bg-surface-800 flex items-center justify-center min-h-screen min-w-screen overflow-hidden">
  <div class="w-1/4 min-w-[320px] flex flex-col items-center justify-center">
    <form [formGroup]="loginForm" (ngSubmit)="login()"
      class="shadow-lg w-full bg-surface-0 dark:bg-surface-900 py-8 px-8 rounded-4xl relative">
      @if (loading()) {
      <div
        class="absolute inset-0 z-50 flex items-center justify-center bg-surface-0/50 dark:bg-surface-900/50 backdrop-blur-sm rounded-4xl">
        <p-progressSpinner [ariaLabel]="'Loading' | transloco"></p-progressSpinner>
      </div>
      }
      <div class="text-center mb-8">
        <img src="logo.svg" class="m-auto dark:hidden" style="height: 290px" [alt]="'Logo' | transloco">
        <img src="logo.dark.svg" class="m-auto hidden dark:block" style="height: 290px" [alt]="'Logo' | transloco">
      </div>

      <div>
        <label for="phone" class="block text-surface-900 dark:text-surface-0 text-xl font-medium mb-2">{{ 'Phone' |
          transloco }}</label>
        <input pSize="large" pInputText id="phone" type="text" placeholder="{{ 'Phone number' | transloco }}"
          class="w-full" formControlName="phone" />
        <p class="block mt-1 mb-2 text-surface-500 dark:text-surface-400">
          {{ 'Phone number format help' | transloco }}
        </p>

        <p-button type="submit" size="large" [label]="'Sign In' | transloco" styleClass="w-full mt-4"
          [disabled]="loginForm.invalid || loading()" />
      </div>
    </form>
  </div>
</div>